import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {TextAreaComponent} from "../../../common/text-area/text-area.component";

@Component({
  selector: 'app-police-report',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule,
    TextAreaComponent
  ],
  templateUrl: './police-report.component.html',
  styleUrl: './police-report.component.css'
})
export class PoliceReportComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: boolean }[] = [];
  radioControl = new FormControl();
  noPoliceReportReason: string | null = null;

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.yes,
        caption: '',
        value: true
      },
      {
        headline: this.locale.currentTranslation.no,
        caption: '',
        value: false
      }
    ];
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.policeReportWasIssued !== null) {
        this.radioControl = new FormControl(this.claimService.claimReport().policeReportWasIssued);
      }
      if (this.claimService.claimReport()?.noPoliceReportReason) {
        this.noPoliceReportReason = this.claimService.claimReport().noPoliceReportReason;
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({
        policeReportWasIssued: this.radioControl.getRawValue(),
        noPoliceReportReason: this.noPoliceReportReason
      });
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['police-report']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    if (rawValue === true) {
      this.showError = false;
    }
    if (rawValue === null) {
      this.showError = true;
    }
    if (rawValue === false) {
      this.showError = this.noPoliceReportReason === null || this.noPoliceReportReason.trim().length == 0;
    }
  }

  setOption(value: boolean) {
    this.radioControl.patchValue(value);
    this.showError = false;
  }
}
